<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button [previousPageUrl]="backUrl$ | async" [previousPageTitle]="'Back'"></glxy-page-nav-button>
    </glxy-page-nav>

    <glxy-page-title>{{ 'EMAIL_STATS.LINK_ACTIVITY' | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <email-link-activity-header
    [selectedLink]="selectedLink$ | async"
    [allLinks]="allLinkActivity$ | async"
    (changeLinkEvent)="changeLink($event)"
  ></email-link-activity-header>

  <email-contact-table
    [attribute]="{ key: attributeKey$ | async, value: attributeValue$ | async }"
    [eventUrl]="url$ | async"
  ></email-contact-table>
</glxy-page>
